import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { hierarchyContext } from "./CompanyHierarchyContext.js";
import { tryPick, tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { unwrap, some, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { RouterModule_encodeParts, RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { createObj, int32ToString } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { singleton, tail, head, isEmpty, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { SnackError } from "./ViewHelpers.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Link, Tab, Tabs, Typography } from "@mui/material";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { View as View_1 } from "./CustomerGroup/CustomerGroupOverview.js";
import { View as View_2 } from "./CustomerGroup/Dashboard/Dashboard.js";
import { CustomerOverview } from "./CustomerGroup/CustomerGroupCustomerView.js";
import { Activities } from "./ActivityView.js";
import { Target } from "./Activities/Services.js";
import { View as View_3, Target as Target_1 } from "./Economy.js";
import { toString } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { ListTarget, List } from "./Ticket/CustomerTicketList.js";

function tabStr(subView) {
    switch (subView) {
        case 0:
            return "overview";
        case 1:
            return "dashboard";
        case 2:
            return "customers";
        case 3:
            return "activity-plan";
        case 4:
            return "history";
        case 5:
            return "economy";
        case 6:
            return "tickets";
        default:
            return "overview";
    }
}

export function View(viewInputProps) {
    let elems_4, elems_1, elems, elems_3, elements, elems_6, elems_5, customers, target, $keyZ1DEA4F41;
    const path = viewInputProps.path;
    const groupId = viewInputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const patternInput = reactApi.useState(undefined);
    let patternInput_1;
    const matchValue = ctx.Session;
    if (matchValue == null) {
        patternInput_1 = [false, false, false];
    }
    else {
        const s = matchValue;
        patternInput_1 = [s.TicketAccess, s.IsSuperAdmin ? true : s.IsAdmin, s.IsPtg];
    }
    const isPTG = patternInput_1[2];
    const isAdmin = patternInput_1[1];
    const groupOpt = tryFind((group) => (group.Id === groupId), hierarchy.Groups);
    const hasCustomerWithActivityPlan = defaultArg(map((group_1) => group_1.Customers.some((_arg) => _arg.EnableServices), groupOpt), false);
    const hasCustomerWithExtra = defaultArg(map((group_2) => group_2.Customers.some((_arg_1) => _arg_1.EnableExtra), groupOpt), false);
    let tabValue;
    let matchResult;
    if (!isEmpty(path)) {
        switch (head(path)) {
            case "overview": {
                if (isEmpty(tail(path))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "dashboard": {
                if (isEmpty(tail(path))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "customers": {
                if (isEmpty(tail(path))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "activity-plan": {
                if (isEmpty(tail(path))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "economy": {
                matchResult = 4;
                break;
            }
            case "tickets": {
                if (isEmpty(tail(path))) {
                    matchResult = 5;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            default:
                matchResult = 6;
        }
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0: {
            tabValue = 0;
            break;
        }
        case 1: {
            if (hasCustomerWithExtra) {
                tabValue = 1;
            }
            else {
                console.error(some("You do not have access to this page"));
                const segment2 = tabStr(0);
                RouterModule_nav(ofArray(["group", int32ToString(groupId), segment2]), 1, 1);
                tabValue = 0;
            }
            break;
        }
        case 2: {
            tabValue = 2;
            break;
        }
        case 3: {
            if (hasCustomerWithActivityPlan) {
                tabValue = 3;
            }
            else {
                const segment2_1 = tabStr(0);
                RouterModule_nav(ofArray(["group", int32ToString(groupId), segment2_1]), 1, 1);
                tabValue = 0;
            }
            break;
        }
        case 4: {
            tabValue = 5;
            break;
        }
        case 5: {
            tabValue = 6;
            break;
        }
        default:
            tabValue = 0;
    }
    reactApi.useEffect(() => {
        if (hierarchy.GroupsFetched) {
            if (groupOpt == null) {
                RouterModule_nav(singleton(""), 1, 1);
            }
        }
    });
    const xs_7 = [createElement(SnackError, {
        errMsg: unwrap(patternInput[0]),
        dismiss: () => {
            patternInput[1](undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        padding: ((((((0 + "px ") + 0) + "px ") + 0) + "px ") + 10) + "px",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        width: 100 + "%",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        minWidth: 10 + "ch",
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h1"], ["noWrap", true], ["children", (groupOpt != null) ? groupOpt.Name : ctx.Locale.t("Loading")]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(singleton((elems_3 = [MuiHelpers_createElement(Tabs, [["variant", "scrollable"], ["indicatorColor", "primary"], ["textColor", "primary"], ["centered", false], ["value", tabValue], ["onChange", (_arg_3, v) => {
        const segment2_2 = tabStr(v);
        RouterModule_nav(ofArray(["group", int32ToString(groupId), segment2_2]), 1, 1);
    }], (elements = toList(delay(() => append(singleton_1(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Overview")], ["value", 0]])), delay(() => append(((isAdmin ? true : isPTG) && hasCustomerWithExtra) ? singleton_1(MuiHelpers_createElement(Tab, [["value", 1], ["label", "Dashboard"]])) : empty(), delay(() => append(singleton_1(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Customers")], ["value", 2]])), delay(() => append(hasCustomerWithActivityPlan ? singleton_1(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.ActivityPlan")], ["value", 3]])) : empty(), delay(() => append(singleton_1(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Economy")], ["value", 5]])), delay(() => (patternInput_1[0] ? singleton_1(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Tickets")], ["value", 6]])) : empty()))))))))))))), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container", "main-tab-container-outer"])], ["style", {
        height: ("calc(" + "100vh - 120px - 30px - 30px - 120px") + ")",
    }], (elems_6 = [createElement("div", {
        className: join(" ", ["main-tab-container-inner"]),
        children: !isEmpty(path) ? ((head(path) === "overview") ? createElement(View_1, {
            groupId: groupId,
        }) : ((head(path) === "dashboard") ? (((isAdmin ? true : isPTG) && hasCustomerWithExtra) ? createElement(View_2, {
            groupId: groupId,
        }) : createElement("div", createObj(singleton((elems_5 = [MuiHelpers_createElement(Typography, [["variant", "h2"], ["children", ctx.Locale.t("NoAccess")]]), MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId)]), 1)], ["onClick", (ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            RouterModule_nav(ofArray(["group", int32ToString(groupId)]), 1, 1);
        }], ["children", ctx.Locale.t("Back")]])], ["children", reactApi.Children.toArray(Array.from(elems_5))]))))) : ((head(path) === "customers") ? createElement(CustomerOverview, {
            groupId: groupId,
        }) : ((head(path) === "activity-plan") ? ((customers = defaultArg(tryPick((group_4) => {
            if (group_4.Id === groupId) {
                return group_4.Customers;
            }
            else {
                return undefined;
            }
        }, hierarchy.Groups), []), createElement(Activities, {
            target: new Target(0, [groupId, customers]),
        }))) : ((head(path) === "economy") ? ((target = (new Target_1(2, [groupId])), ($keyZ1DEA4F41 = toString(target), createElement(View_3, {
            key: $keyZ1DEA4F41,
            $key: $keyZ1DEA4F41,
            target: target,
        })))) : ((head(path) === "tickets") ? createElement(List, {
            target: new ListTarget(0, [groupId]),
        }) : createElement("p", {
            children: ["404"],
        }))))))) : createElement(View_1, {
            groupId: groupId,
        }),
    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))];
    return react.createElement(react.Fragment, {}, ...xs_7);
}

